import { DocumentReference, Bundle } from "fhir/r5";
import Client from "fhir-kit-client";
import { Board } from "@fyrstain/fhir-front-library";
import UserService from "../../services/UserService";
// Buffer
import { Buffer } from 'buffer';

/////////////////////////////////////
//             Client              //
/////////////////////////////////////

const fhirClient = createFhirClient();

function createFhirClient(): Client {
  const baseUrl = process.env.REACT_APP_DOCUMENT_URL ?? "fhir";
  return new Client({ baseUrl });
}

/////////////////////////////////////
//         Business methods        //
/////////////////////////////////////


async function getAllBoard(): Promise<Board[]> {
    const resultDR: DocumentReference[] = await searchDocumentReference(UserService.getUsername(), "board");
    return resultDR.map(dr => {
            return JSON.parse(
                Buffer.from(dr.content.map(c => c.attachment.data).find(d => d) ?? '', 'base64')
                .toString()
            ) as Board
        }
    );
};

async function saveBoard(board: Board): Promise<void> {
    const resultDR: DocumentReference[] = await searchDocumentReference(UserService.getUsername(), "board", board.id);
    const base64 = Buffer.from(JSON.stringify(board)).toString('base64');
    
    if (resultDR.length === 1) {
        const documentReference= resultDR[0]; 
        const content = documentReference.content.find(c => c);
        if (content) {
            content.attachment.data = base64;
        }
        await updateDocumentReference(documentReference);
    } else if (resultDR.length === 0) {
        const documentReference = { resourceType: "DocumentReference" } as DocumentReference;
        documentReference.type = { coding: [{system: "jupiter", code: "board"}] };
        documentReference.identifier = [
            {
                system: "jupiter",
                value: board.id,
            },
            {
                "system": "urn:olympus:user-id",
                "value": UserService.getUsername() ?? "undefined"
            }
        ]
        documentReference.subject = {display: UserService.getUsername()};
        documentReference.status = "current";
        documentReference.content = [
            {
                attachment: {
                    contentType: "application/json",
                    data: base64
                }
            }
        ];
        await createDocumentReference(documentReference);
    } else {
        throw new Error("Found to many result");
    };
};

async function deleteBoard(boardId: string): Promise<void> {
    const resultDR: DocumentReference[] = await searchDocumentReference(UserService.getUsername(), "board", boardId);
    if (resultDR.length === 1) {
        const documentReference= resultDR[0]; 
        await deleteDocumentReference(documentReference.id ?? '');
    } else if (resultDR.length === 0) {
        return;
    } else {
        throw new Error("Found to many result");
    };
};

/////////////////////////////////////
//           FHIR methods          //
/////////////////////////////////////

async function searchDocumentReference(subject?: string, type?: string, identifier?: string): Promise<DocumentReference[]> {
    try {
    var searchParams: {} = {};

    var identifiers = [ "urn:olympus:user-id|" + subject ];

    if (identifier) {
        identifiers = [...identifiers, 
            identifier
        ];
    }

    searchParams = {
        ...searchParams,
        identifier: identifiers
    }

    if (type) {
        searchParams = {
            ...searchParams,
            type: type
        }
    }
    const response = await fhirClient.search({
                resourceType: 'DocumentReference',
                searchParams: searchParams
            });

    if (response.resourceType !== 'Bundle') {
        throw Error(response.statusText);
    }

    const bundle: Bundle = response as Bundle;
    return bundle.entry?.filter(
            entry => 'DocumentReference' === entry.resource?.resourceType
        ).map(
            entry => entry.resource as DocumentReference
        ) ?? [];
} catch (error) {
            console.log(error);
            throw error;
        }
}

async function createDocumentReference(documentReference: DocumentReference): Promise<void> {
    try {
        await fhirClient.create({
            resourceType: "DocumentReference",
            body: documentReference,
        });
    } catch (error) {
        console.log(error);
        throw error;
    }
}

async function updateDocumentReference(documentReference: DocumentReference): Promise<void> {
    try {
        await fhirClient.update({
            resourceType: "DocumentReference",
            id: documentReference.id ?? '',
            body: documentReference,
        });
    } catch (error) {
        console.log(error);
        throw error;
    }
}

async function deleteDocumentReference(id: string): Promise<void> {
    try {
        await fhirClient.delete({
            resourceType: "DocumentReference",
            id: id ?? '',
        });
    } catch (error) {
        console.log(error);
        throw error;
    }
}

const BoardService = {
  saveBoard,
  deleteBoard,
  getAllBoard,
};

export default BoardService;